import { render, staticRenderFns } from "./3.vue?vue&type=template&id=3a264564&scoped=true&"
import script from "./3.vue?vue&type=script&lang=js&"
export * from "./3.vue?vue&type=script&lang=js&"
import style0 from "./3.vue?vue&type=style&index=0&id=3a264564&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a264564",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib'
import { VBtn } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VFadeTransition } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VScaleTransition } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
installComponents(component, {VAvatar,VBtn,VContainer,VFadeTransition,VFlex,VIcon,VLayout,VScaleTransition,VSpacer})


/* vuetify-loader */
import installDirectives from "!/app/node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import { Ripple } from 'vuetify/lib/directives'
installDirectives(component, {Ripple})
